import React,{Component} from 'react';
import "./header/Header.css"; 
import "../scss/general.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css';
import ReactToPdf from "react-to-pdf";
import logo from "./images/loading.gif";
import '../scss/green-theme.css';
import Cookies from "universal-cookie";
import ModalLogin from './ModalLogin';
import * as XLSX from 'xlsx'
import { DownloadTableExcel } from 'react-export-table-to-excel';
const axios = require("axios");
const ref = React.createRef(null);
const cookies = new Cookies();
export default class AdminLeavesDetail extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { input:{},
      myitems:[],
      isLoaded: false,
      isData: false,
      EmployeeID: "",
      Name:"",
      Designation:"",
      Location:"",
      fromDate: new Date(),
      toDate: new Date(),
      ErrMsg:"",
      errorcss:"labelsave",
      errortext:"",
      dived:"none",
      fdate: Moment(new Date()).format("DD/MM/YYYY"),
      tdate: Moment(new Date()).format("DD/MM/YYYY")
    };
    this.handlechangefrom = this.handlechangefrom.bind(this);
    this.handlechangeto = this.handlechangeto.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeS = this.handleChangeS.bind(this);
  }
  downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(this.state.myitems);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "DataSheet.xlsx");
  };

  cur(num) 
  {
    let cnum=parseFloat(num,1);
    if(cnum > 0)
        return cnum.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
 }
 componentDidMount()
 {
    let input = this.state.input;
    if(cookies.get("LoginID"))
    { input["ID"]=cookies.get("LoginID");
      this.setState({ErrMsg:""});
    }
    else
    { this.setState({ErrMsg:<ModalLogin/>});}
 }

 handleChangeS(e)
 {
    this.setState({EmployeeID: e.target.value});
 }
  handlechangefrom(date)
  {
    this.setState({fdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({fromDate: date});
  }
  handlechangeto(date)
  {
    this.setState({tdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({toDate:date});
  }

  handleSubmit()
  {
      document.body.style.cursor="wait";
      this.setState({ErrMsg:<img src={logo}  alt=""/>});
      let input=this.state.input;
      input["DateFrom"]=this.state.fdate;
      input["DateTo"]=this.state.tdate;
      input["EmployeeID"]=this.state.EmployeeID;
      this.setState({input,isLoaded: false,errortext:""});
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/LeavesDetail/',
          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
          if(response.data === 0)
          {
            document.body.style.cursor="default";
            this.setState({
              ErrMsg:"",
              errortext:"No record found OR something wrong now.",errorcss:"labelerror",dived:"none"});
          }
          else
          {
              document.body.style.cursor="default";
              this.setState({
                isLoaded: true,
                ErrMsg:"",
                errortext:"",
                Name:response.data[1].name,
                Designation:response.data[1].desig,
                Location:response.data[1].location,
                dived:"block",
                myitems: response.data
            });
          }
      })
      .catch((response)=> {
        console.log(response.data);
        document.body.style.cursor="default";
        this.setState({errortext:"No record found OR something wrong now.",errorcss:"labelerror",ErrMsg:"",dived:"none"});
      });      
    }
    render(){
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      let fileName="LeaveDetail.pdf";
{/*}      if(!isLoaded){
      return(
        <div >
          <br></br>
          <div className="inner-profile33-all" >

          <div className="inner-profile2" >
          <table className="csstable">

            <thead>
            </thead>
            <tbody>            
            <tr>
              <td style={{width:"75px",padding:".5px"}} >From:</td>
                  <td style={{width:"50px",padding:".5px"}}>
                      <DatePicker
                          selected={this.state.fromDate }
                          value = {this.state.fromDate}
                          onChange={this.handlechangefrom}
                          name="fromDate"
                          dateFormat="dd/MM/yyyy" className="form_control" />
                  </td>  
                  <td style={{textAlign:"center",width:"5px"}} > - </td>
                  <td style={{width:"50px",padding:".5px"}} >
                      <DatePicker
                          selected={ this.state.toDate }
                          value = {this.state.toDate}
                          onChange={this.handlechangeto}
                          name="toDate"
                          dateFormat="dd/MM/yyyy" className="form_control"/>
                  </td>  
                </tr>
                <td style={{width:"75px",padding:".5px"}} >Employee ID:</td>
                  <td style={{width:"50px",padding:".5px"}} >
                    <input className="form-control" style={{width:"100px",height:"25px"}} onBlur={this.handleChangeS}/>
                  </td> 
                <tr>
                <td  align="right" paddingTop="5px" height="30px" colSpan="5">
                <button onClick={this.handleSubmit} className="btn btn-secondary active">Submit</button>
                </td></tr>
                <tr>
                <td  width="100px" ></td>
                        <td colSpan="5" style={{width:"75px",paddingTop:"0px",fontSize:"10pt",align:"left"}}>
                            <span className={this.state.errorcss}>{this.state.errortext}</span>
                        </td>
                </tr>                             
                </tbody>
              </table>
              </div>
        </div>
            <div  style={{paddingTop:"30px",height:"200px",textAlign:"center",width:"90%"}}>
                  {this.state.ErrMsg}
              </div>

        </div>
}      )
    }
    else
    {*/
      return(
        <div style={{marginTop:"25px"}}>
          <div className="inner-profile33-all" >
          <br></br>
          <div className="inner-profile2" >
          <table className="csstable">

            <thead>
            </thead>
            <tbody>            
            <tr>
              <td width="125px" align="left" padding=".5px" >From:</td>
                  <td width="75px" align="left" padding="1px">
                      <DatePicker
                          selected={this.state.fromDate }
                          value = {this.state.fromDate}
                          onChange={this.handlechangefrom}
                          name="fromDate"
                          dateFormat="dd/MM/yyyy" className="form_control"/>
                  </td>  
                  <td style={{textAlign:"center",width:"5px"}} > - </td>
                  <td width="75px" align="left" padding="1px" >
                      <DatePicker
                          selected={ this.state.toDate }
                          value = {this.state.toDate}
                          onChange={this.handlechangeto}
                          name="toDate"
                          dateFormat="dd/MM/yyyy" className="form_control"/>
                  </td>  
                </tr>
                <td width="125px" align="left" padding=".5px" >Employee ID:</td>
                  <td width="75px" align="left" padding=".5px" >
                    <input className="form-control" style={{width:"100px",height:"25px"}} onBlur={this.handleChangeS}/>
                  </td> 
                <tr>
                <td  align="right" paddingTop="5px" height="30px" colSpan="5">
                <button onClick={this.handleSubmit} className="btn btn-secondary active">Submit</button>
                </td></tr>
                <tr>
                <td  width="100px" ></td>
                        <td colSpan="5" style={{width:"100px",paddingTop:"0px",fontSize:"10pt",align:"left"}}>
                            <span className={this.state.errorcss}>{this.state.errortext}</span>
                        </td>
                </tr>                             
                </tbody>
              </table>
              </div>
              <div style={{width:"90%",align:"center",display:this.state.dived}} >
              <br></br> 
              <br></br> 
              <br></br> 


            <div ref={ref} >
            <div style={{textAlign:"left",width:"100%",marginLeft:"10%"}} >
            <h4 style={{textAlign:"center",width:"100%"}}>Leave Detail</h4>
            <h6>{this.state.Name} ({this.state.EmployeeID})</h6>
            <h6>{this.state.Designation}</h6>
            <h6>{this.state.Location}</h6>
            </div>

            <table style={{align:"left", id:"DReport",name:"DReport", width:"100%",marginLeft:"10%"}}   >
                <tr align="left">
                <div width="100%"  >
                        {/*<h3>{config.gvr.ErrMsgs.Comp_Name}</h3>*/}
                            <table width="90%" align="left">
                                <tr>
                                        <th className="thm" scope="col" >Leave From</th>
                                        <th className="thm" scope="col" >Leave To</th>
                                        <th className="thm" scope="col">Annual</th>
                                        <th className="thm" scope="col">Sick</th>
                                        <th className="thm" scope="col">Casual</th>
                                        <th className="thm" scope="col">LWP</th>
                                        <th className="thm" scope="col">Compensatory</th>
                                        <th className="thm" scope="col">Total</th>
                                  </tr>
                                      {items.map((result ,i) => {
                                          return (
                                            <tr className="trc" key={i}>
                                              <td className="tdamcenter" >{Moment(result.leave_from).format("DD/MM/YYYY")}</td>
                                              <td className="tdamcenter" >{Moment(result.leave_to).format("DD/MM/YYYY")}</td>
                                              <td className="tdamcenter" >{this.cur(result.annual)}</td>
                                              <td className="tdamcenter" >{this.cur(result.sick)}</td>
                                              <td className="tdamcenter" >{this.cur(result.casual)}</td>
                                              <td className="tdamcenter" >{this.cur(result.lwp)}</td>
                                              <td className="tdamcenter" >{this.cur(result.compensatory)}</td>
                                              <td className="tdamcenter" >{this.cur(result.tdays)}</td>
                                            </tr>
                                          )})}
                            </table>
                        </div>
                    </tr>
                  </table>
                  </div>
                <br></br>

                <div style={{textAlign:"center",width:"100%"}} >
{/*}                <button  onClick={()=>this.downloadExcel()} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download Excel</button>*/}

                <DownloadTableExcel
                    filename="LeaveDetail.xlsx"
                    sheet="users"
                    currentTableRef={ref.current}
                >

                <button  style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download Excel</button>

                </DownloadTableExcel>                                  
                    <ReactToPdf targetRef={ref} filename={fileName} x={5} y={3} >
                        {({toPdf}) => (
                        <button onClick={toPdf} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                        )}
                        </ReactToPdf>
                </div>
            </div>
            <br></br>            <br></br>

            
            </div>
            <div style={{width:"80%",textAlign:"center"}} >
              {this.state.ErrMsg}
             </div>
            
        </div>
      );
    }}}